<section class="assinatura-shell">
  <ol class="passos">
    <li>
      <button type="button" class="passo" (click)="voltarCatalogo()">
        <span class="passo-icone"><i class="bi bi-cart3"></i></span>
        <span>
          <strong>1. Catálogo</strong>
          <small>Produtos</small>
        </span>
      </button>
    </li>
    <li class="passo-linha" [class.ativo]="passo === 'contrato'"></li>
    <li>
      <button
        type="button"
        class="passo"
        [class.atual]="passo === 'contrato'"
        (click)="irPara('contrato')"
      >
        <span class="passo-icone"><i class="bi bi-file-earmark-text"></i></span>
        <span>
          <strong>2. Contrato</strong>
          <small>Assinatura</small>
        </span>
      </button>
    </li>
    <li class="passo-linha" [class.ativo]="passo === 'checkout'"></li>
    <li>
      <button
        type="button"
        class="passo"
        [class.atual]="passo === 'checkout'"
        (click)="tentarCheckout()"
      >
        <span class="passo-icone"><i class="bi bi-truck"></i></span>
        <span>
          <strong>3. Checkout</strong>
          <small>Endereço e forma de pagamento</small>
        </span>
      </button>
    </li>
  </ol>

  <div class="assinatura-corpo" *ngIf="passo === 'contrato'">
    <div class="grade-formulario">
      <div class="coluna-principal">
      <article class="card-bloco">
        <header class="card-titulo">
          <span class="icone-doc"><i class="bi bi-file-earmark-text"></i></span>
          <div>
            <h1>
              Contrato Comercial
              <span class="selo" *ngIf="consulta?.contrato_obrigatorio !== false">Obrigatório</span>
            </h1>
            <p>Leia o contrato com atenção e realize a assinatura para prosseguir com o seu pedido.</p>
          </div>
        </header>

        <div class="visor-contrato">
          <iframe *ngIf="contratoHtml; else contratoSkeleton" [srcdoc]="contratoHtml" title="Contrato"></iframe>
          <ng-template #contratoSkeleton>
            <div class="contrato-skeleton" aria-hidden="true">
              <span class="sk sk-titulo"></span>
              <span class="sk sk-linha"></span>
              <span class="sk sk-linha"></span>
              <span class="sk sk-linha sk-curta"></span>
              <span class="sk sk-bloco"></span>
              <span class="sk sk-linha"></span>
              <span class="sk sk-linha"></span>
              <span class="sk sk-linha sk-media"></span>
            </div>
          </ng-template>
        </div>
        <div class="acoes-doc">
          <button type="button" class="btn-linha" (click)="baixar()" [disabled]="carregando">
            <i class="bi bi-download"></i> Baixar PDF
          </button>
        </div>
      </article>

      <article class="duvida">
        <i class="bi bi-question-circle"></i>
        <div>
          <strong>Dúvidas sobre o contrato?</strong>
          <p>Em caso de dúvidas, entre em contato com o seu representante comercial.</p>
        </div>
      </article>
      </div>

      <aside class="coluna-lateral">
        <article class="card-bloco painel">
          <header class="status-topo">
            <i class="bi bi-clock"></i>
            <strong>Status da assinatura</strong>
            <span class="badge" [ngClass]="status || 'PENDENTE'">{{ badge }}</span>
          </header>
          <p class="status-texto">{{ textoStatus }}</p>
          <p class="aviso-erro" *ngIf="erroStatus">{{ erroStatus }}</p>
          <button
            type="button"
            class="btn-principal"
            (click)="acaoPrincipal()"
            [disabled]="acaoPrincipalDesabilitada"
          >
            <span>
              <strong>{{ textoAcaoPrincipal }}</strong>
              <small>{{ dicaAcaoPrincipal }}</small>
            </span>
          </button>
          <button
            type="button"
            class="btn-secundario"
            (click)="copiarLink()"
            [disabled]="!consulta?.contrato?.url_assinatura"
          >
            <span>
              <strong>{{ linkCopiado ? "Link copiado" : "Copiar link para assinatura" }}</strong>
              <small>Copia o link para enviar por e-mail ou outro canal.</small>
            </span>
          </button>
          <button type="button" class="btn-secundario" (click)="verificar()" [disabled]="carregando">
            <span>
              <strong>Verificar assinatura</strong>
              <small>Atualiza o status da assinatura.</small>
            </span>
          </button>
          <button type="button" class="btn-dispensa" (click)="abrirAutorizacao()" [disabled]="carregando">
            <span>
              <strong>Autorizar pedido sem contrato</strong>
              <small>Permite seguir com o pedido sem a assinatura. Será registrado no histórico.</small>
            </span>
          </button>
          <button type="button" class="btn-continuar" (click)="tentarCheckout()">
            Continuar para o checkout
          </button>
          <small class="aviso-checkout" *ngIf="!podeIrCheckout">A assinatura do contrato é obrigatória para prosseguir.</small>
        </article>
      </aside>
    </div>
  </div>

  <div class="fundo-modal" *ngIf="confirmarAutorizacao" (click)="cancelarAutorizacao()">
    <section class="modal-autorizacao" (click)="$event.stopPropagation()">
      <h2>Autorizar pedido sem assinatura</h2>
      <p>Este pedido será liberado para o checkout sem a assinatura do contrato comercial.</p>
      <label>
        Motivo da autorização
        <textarea
          [(ngModel)]="motivoAutorizacao"
          rows="4"
          required
          placeholder="Descreva o motivo da autorização"
        ></textarea>
      </label>
      <p class="nota">Essa ação ficará registrada no histórico do pedido.</p>
      <p class="aviso-erro" *ngIf="erroStatus">{{ erroStatus }}</p>
      <footer>
        <button type="button" class="btn-linha" (click)="cancelarAutorizacao()">Cancelar</button>
        <button
          type="button"
          class="btn-confirmar"
          [disabled]="!motivoAutorizacao.trim() || carregando"
          (click)="confirmarDispensa()"
        >
          Confirmar autorização
        </button>
      </footer>
    </section>
  </div>
</section>
